import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {getLocalStorageVariables,
    isEmptyVariable, isEmptyArray, getStatusSpan,
    handleTokenExpiry} from '../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import TreeNodeDropdown from '../../../common/DropdownMenus/TreeNodeDropdown';
import AddHeadingDialog from './addHeadingdialog'
import AlertDialog from '../../../common/AlertDialog';
import AlertWithRadioDialog from '../../../common/AlertDialog/alertwithradioChecklist';
import {ExpandCollapseWrapper} from '../../../common/Global/globalStyles.style';
import { TreeViewComponent } from '@syncfusion/ej2-react-navigations';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-navigations/styles/material.css";
import "@syncfusion/ej2-inputs/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import ProcessFunctionListDialog from "../ProcessFunctionsDialog/processFunctionsList"
let userDetails = getLocalStorageVariables();

const deletedStatus="Deleted";
const AddChildDropdownObj = {
    icon:"add_circle",
    label:"Add Child"
}
const AddSiblingDropdownObj = {
    icon:"add_box",
    label:"Add Sibling"
}
const editDropdownObj = {
    icon:"edit",
    label:"Edit"
}
const delDropdownObj = {
    icon:"delete",
    label:"Delete"
}
const AddRemoveDropdownObj = {
    icon:"add_box",
    label:"Add/Remove Tasks"
}

class HeadingTreeDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader:false,
            showBtnLoader:false,
            headingMap:{},
            actionArr:[],
            syncFusionData:[],
            rootCheckListHeadingId:"",

            showCreateDialog:false,
            isEdit:false,
            createNodeType:"",
            selectedId:"",
            heading:"",
            relativeFunctionId:"",
            clearAndResetFunctionTree:true,
            idToBeExpandedAfterAddingChild:"",

            operationType:"",
            deleteReactivateId:"",
            showAlertWithRadioDialog:false,
            alertWithRadioDialogMessage:"",
            showRadio:true,
            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",

            showProcessFunctionsDialog:false,
        }
        this.fields = {};
        this.headingObj = {};
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showHeadingTreeDialog){
            this.fields = {
                dataSource:[],
                id:"checkListHeadingId",
                text:"heading",
                parentID:"parentId",
                child:"newChildren",
                expanded:"isExpanded"
            };

            this.setState({
                showLoader:false,
                showBtnLoader:false,
                headingMap:{},
                actionArr:[],
                syncFusionData:[],
                rootCheckListHeadingId:"",
    
                showCreateDialog:false,
                isEdit:false,
                createNodeType:"",
                selectedId:"",
                heading:"",
                relativeFunctionId:"",
                clearAndResetFunctionTree:true,
                idToBeExpandedAfterAddingChild:"",

                operationType:"",
                deleteReactivateId:"",
                showAlertWithRadioDialog:false,
                alertWithRadioDialogMessage:"",

                showAlertDialogInfo:false,
                alertDialogMessageInfo:"",
            },()=>{
                this.getFunctionTree();
            })
            
        }
    }

    handleAddEditDialogClose = (reloadFlag) =>{
        let id = "";
        if(this.state.createNodeType === "child") id = this.state.relativeFunctionId;
        this.setState({
            showCreateDialog:false,
            clearAndResetFunctionTree:false,
            isEdit:false,
            createNodeType:"",
            selectedId:"",
            heading:"",
            relativeFunctionId:"",
            idToBeExpandedAfterAddingChild:id,
        },()=>{
            if(reloadFlag === true) this.getFunctionTree();
        })
    }

    onDropDownItemClick = (item,headingObj) => {
        if(item.label === "Add Child"){
            this.setState({
                showCreateDialog:true,
                createNodeType:"child",
                relativeFunctionId:headingObj.checkListHeadingId,
                
                isEdit:false,
            })
        }else if(item.label === "Add Sibling"){
            this.setState({
                showCreateDialog:true,
                createNodeType:"sibling",
                relativeFunctionId:headingObj.parentHeadingId,
                
                isEdit:false,
            })
        }else if(item.label === "Delete"){
            let showRadio = true;
            // if(isEmptyArray(this.state.headingMap[headingObj.checkListHeadingId].children)){
            //     showRadio = false
            // }

            this.setState({
                operationType:item.label,
                deleteReactivateId:headingObj.checkListHeadingId,
                showAlertWithRadioDialog:true,
                showRadio:showRadio,
                alertWithRadioDialogMessage:"Are you sure you want to delete "+headingObj.heading+"?"
            })
        }else if(item.label === "Edit"){
            this.setState({
                showCreateDialog:true,
                createNodeType:"sibling",
                relativeFunctionId:headingObj.checkListHeadingId,
                
                isEdit:true,
                selectedId:headingObj.checkListHeadingId,
                heading:headingObj.heading,
            })
        }else if(item.label === "Add/Remove Tasks"){
            this.setState({
                showProcessFunctionsDialog:true,
                selectedId:headingObj.checkListHeadingId,
                heading:headingObj.heading,
            })
        }
    }

    // Directly open task screen based on if statement
    onItemClick = (headingObj) => {
        // If the item's level is greater than 1 and the title type is 'nodeName'
        if(headingObj.level > 1 && this.state.titleType == 'nodeName'){
            this.props.handleActionDropdownItemClick(this.props.rootNode,this.props.currentPageNo,
                this.props.searchkey,
                this.props.resultSize,
                this.props.sort,this.props.sortDir,this.props.status,"addRemoveTasks","process",
                headingObj.nodeId,this.state.titleType,this.props.rootCheckListVersionId,headingObj.checkListHeadingId,headingObj.heading,
                this.props.departmentId,true);
        }
    }

    handleProcessFuncDialogClose = () => {
        this.setState({
            showProcessFunctionsDialog:false,
            selectedId:"",
            heading:"",
        })
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleAlertWithDialogDialogClose = () =>{
        this.setState({
            showAlertWithRadioDialog:false,
            alertWithRadioDialogMessage:""
        });
    }

    handleAlertDialogCloseInfo = () =>{
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

    getRootLevelFunctions = (functionMapTemp) => {
        let rootFunctionArr = [];
        Object.values(functionMapTemp).map((item)=>{
            if(item.level === 0){
                rootFunctionArr.push(item);
            }
        })
        return rootFunctionArr;
    }

    //No need of return value since the array itself is passed and updated.
    //Javascript maintains single array with pointers. it will not deep copy the array
    addParentIdandHasChildrenFlag = (tempArr, checkListHeadingId, level,parentHeadingId) => {
        tempArr[checkListHeadingId].level = level;
        tempArr[checkListHeadingId].parentHeadingId = parentHeadingId;

        if(!isEmptyArray(tempArr[checkListHeadingId].children)){
            tempArr[checkListHeadingId].children.map(childNode => {
                this.addParentIdandHasChildrenFlag(tempArr,childNode.headingId,level+1,checkListHeadingId);
            });
        }else{
            tempArr[checkListHeadingId].hasChildren = false;
        }
    }

    /************************API CALLS **************************/
    HeadingTree = (headingObj) => {
        let spanObj = getStatusSpan(headingObj.status,this.props.themeSettings);
        return <div className="dialog-tree-structure-sync">
        {
            !isEmptyVariable(headingObj) &&
                <div className="tree-node-sync">
                    {
                        this.props.rootNode.allowEdit === "N" &&
                        <div className="tree-text-layout">
                            <p className={headingObj.fontbold?"font-bold":""}>
                                {headingObj.heading + " ("+headingObj.taskList.length+")"}
                            </p>
                            {
                                !isEmptyVariable(spanObj.spanText) &&
                                <span style={spanObj.spanStyle} className="span-tag">
                                    {spanObj.spanText}
                                </span>
                            }
                        </div>
                    }
                    {
                        this.props.rootNode.allowEdit === "Y" &&
                        <div className="tree-dropdown-layout-sync">
                            <TreeNodeDropdown
                                placeholder={headingObj.heading + " ("+headingObj.taskList.length+")"}
                                dropdownArr={
                                    headingObj.status === deletedStatus?[]:
                                    (headingObj.level === 1
                                    ?
                                    this.state.actionArrRoot
                                    :
                                    this.state.actionArr)
                                }
                                labelParam={"label"}
                                onDropDownItemClick={this.onDropDownItemClick}
                                onItemClick={() => this.onItemClick(headingObj)}
                                dropdownId={headingObj}
                                fontbold={headingObj.fontbold}
                                paraMT={"1.5px"}
                                themeSettings={this.props.themeSettings}
                            />
                            {
                                !isEmptyVariable(spanObj.spanText) &&
                                <span style={spanObj.spanStyle} className="span-tag">
                                    {spanObj.spanText}
                                </span>
                            }
                        </div>
                    }
                    
                </div>
            }
        </div>
    }

    createSyncHRFusionData = (parentId,checkListHeadingId,headingMap,isExpanded) => {
        //Now create an object
        let headingObj = headingMap[checkListHeadingId];
        headingObj.newChildren = [];
        headingObj.isExpanded = isExpanded;
        if(parentId !== checkListHeadingId){
            headingObj.parentId = parentId;
        }

        //now add children recursively
        headingObj.children.map((item)=>{
            headingObj.newChildren.push(this.createSyncHRFusionData(checkListHeadingId,item.headingId,headingMap,false));
        });
        return headingObj;
    }

    updateSyncHRFusionData = (parentId,checkListHeadingId,headingMap) => {
        //Now create an object
        let headingObj = headingMap[checkListHeadingId];
        headingObj.newChildren = [];

        //Check the old function map
        if(!isEmptyVariable(this.state.headingMap[checkListHeadingId])){
            headingObj.isExpanded = this.state.headingMap[checkListHeadingId].isExpanded;
            headingMap[checkListHeadingId].isExpanded = this.state.headingMap[checkListHeadingId].isExpanded;
        }

        if(parentId !== checkListHeadingId){
            headingObj.parentId = parentId;
        }

        //now add children recursively
        headingObj.children.map((item)=>{
            headingObj.newChildren.push(this.updateSyncHRFusionData(checkListHeadingId,item.headingId,headingMap));
        });
        return headingObj;
    }

    deleteActivateFunctionNode = (deleteChildren) => {
        let url = "";

        if(this.state.operationType === "Delete"){
            url = Constants.DeleteChecklistHeadings;
        }

        this.setState({
            showBtnLoader:true,
        });

        fetch(url,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                checkListHeadingId:this.state.deleteReactivateId,
                deleteChildrenTasks:deleteChildren,
                deleteSubheadings:deleteChildren,
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    deleteReactivateId:"",
                    operationType:"",
                    alertWithRadioDialogMessage:"",
                    showAlertWithRadioDialog:false,
                    clearAndResetFunctionTree:false,
                    showBtnLoader:false
                },() => {
                    this.getFunctionTree();
                });
            }else{
                this.setState({
                    showBtnLoader:false,
                    deleteReactivateId:"",
                    operationType:"",
                    alertWithRadioDialogMessage:"",
                    showAlertWithRadioDialog:false,
                    clearAndResetFunctionTree:false,

                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                })
            }
        });
    }

    getFunctionTree = () => {
        this.setState({
            showLoader:true,
        });

        fetch(Constants.GetChecklistHeadings,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                checkListVersionId:this.props.rootCheckListVersionId,
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let temp = data.result.headingMap;
                let rootFunctionArr = this.getRootLevelFunctions(temp);
                let rootCheckListHeadingId = "";

                rootFunctionArr.map((rootNode)=>{
                    rootCheckListHeadingId = rootNode.checkListHeadingId;
                    this.addParentIdandHasChildrenFlag(temp,rootNode.checkListHeadingId,1,rootNode.checkListHeadingId)
                })

                let syncFusionData = [];
                //clearAndResetFunctionTree - if it is false, then copy the isShowingChildren param 
                //from old state array, this is required because whenever the user adds a new node at the nth level
                //all the nodes are collapsed and shows only first level nodes since the API is called again
                if(!isEmptyArray(Object.keys(this.state.headingMap)) && 
                !this.state.clearAndResetFunctionTree){
                    let headingObj = this.updateSyncHRFusionData(rootCheckListHeadingId,rootCheckListHeadingId,temp);
                    headingObj.fontbold = true;
                    syncFusionData.push(headingObj);
                }else{
                    //create datastructure and Expand root level node's children by default
                    let headingObj = this.createSyncHRFusionData(rootCheckListHeadingId,rootCheckListHeadingId,temp,true);
                    temp[rootCheckListHeadingId].isExpanded = true;
                    headingObj.fontbold = true;
                    syncFusionData.push(headingObj);
                }
                //Action item arrays based on allowEdit flag
                let actionArrTemp = [];
                let actionArrRootTemp = [];
                if(this.props.rootNode.allowEdit === "Y"){
                    if(temp[rootCheckListHeadingId].titleType == "nodeName"){
                        actionArrTemp = []
                        actionArrRootTemp = [AddRemoveDropdownObj]
                    }else{
                        actionArrTemp = [AddRemoveDropdownObj,AddChildDropdownObj,AddSiblingDropdownObj,editDropdownObj,delDropdownObj]
                        actionArrRootTemp = [AddRemoveDropdownObj,AddChildDropdownObj,editDropdownObj]
                    }
                }

                //set the tree fields
                this.fields = {
                    dataSource:syncFusionData,
                    id:"checkListHeadingId",
                    text:"heading",
                    parentID:"parentId",
                    child:"newChildren",
                    expanded:"isExpanded"
                };

                this.setState({
                    headingMap:temp,
                    actionArr:actionArrTemp,
                    actionArrRoot:actionArrRootTemp,
                    idToBeExpandedAfterAddingChild:"",
                    syncFusionData:syncFusionData,
                    rootCheckListHeadingId:rootCheckListHeadingId,
                    showLoader:false,
                    clearAndResetFunctionTree:false,
                    titleType:temp[rootCheckListHeadingId].titleType
                },()=>{
                    this.reference.refresh();
                });
            }else{
                this.setState({
                    headingMap:{},
                    showLoader:false,
                    syncFusionData:[],
                    clearAndResetFunctionTree:false
                });
            }
        });
    }

    moveTask = (draggedNodeId,draggedNodePid,droppedNodePid,droppedPos) => {
        fetch(Constants.MoveChecklistHeading,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                
                rootHeadingId:this.state.rootCheckListHeadingId,
                headingId:draggedNodeId,
                
                fromHeadingId:draggedNodePid,
                toHeadingId:droppedNodePid,
                toChildOrder:droppedPos,
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else {
                this.getFunctionTree();
            }
        });
    }

    expandAll = () => {
        this.reference.expandAll();
    }

    collapseAll = () => {
        this.reference.collapseAll();
    }

    dragStop = (args)=>{
        // console.log("Drag Node: "+JSON.stringify(args.draggedNodeData))
        // console.log("Drop Node: "+JSON.stringify(args.droppedNodeData))
        // console.log("Drop Level: "+args.dropLevel)

        //if the node is dropped above the parent node then cancel the drag
        if(args.dropLevel === 1){
            args.cancel = true;
        }
    }
    nodeExpanded = (args) =>{
        this.state.headingMap[args.nodeData.id].isExpanded = true;
    }
    nodeCollapsed = (args) =>{
        this.state.headingMap[args.nodeData.id].isExpanded = false;
    }
    nodeDrop = (args) => {

        let draggedNodeId = "";
        let draggedNodePid = "";

        let droppedNodeid = "";
        let droppedNodePid = "";
        let droppedPos = "";
        let dropLevel = "";

        if(!isEmptyVariable(args.draggedNodeData) && !isEmptyVariable(args.droppedNodeData)){
            draggedNodeId = args.draggedNodeData.id;
            draggedNodePid = args.draggedNodeData.parentID;

            droppedNodeid = args.droppedNodeData.id;
            droppedNodePid = args.droppedNodeData.parentID;
            droppedPos = args.dropIndex + 1;
            dropLevel = args.dropLevel;

            // now check what is the level of drop id
            let dropRelativeNodeLevel = this.state.headingMap[droppedNodeid].level;
            //dropped level is greater than relative node, then it is a child of that relative node
            //hence parent id is relative node id
            if(dropLevel > dropRelativeNodeLevel){
                droppedNodePid = droppedNodeid;
            }

            this.moveTask(draggedNodeId,draggedNodePid,droppedNodePid,droppedPos);
        }
    }

    render() {
        // console.log(JSON.stringify(this.fields))
        let dnd = false;
        if(!isEmptyVariable(this.props.rootNode) && this.props.rootNode.allowEdit === "Y"){
            dnd = true;
        }
        
        return(
            <div>
                <Modal className="show-functions-tree-dialog custom-dialog" 
                show={this.props.showHeadingTreeDialog} 
                backdrop="static">
                    <Modal.Header>
                        <h5>Checklist Heading</h5>
                        <button 
                            onClick={this.props.handleHeadingTreeDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        {
                            this.state.showLoader &&
                            <div class="loader"></div>
                        }
                        <ExpandCollapseWrapper themeSettings={this.props.themeSettings}>
                            <div className="expand-collapse-layout"
                                onClick={this.expandAll}
                                style={{marginRight:10}}
                                type="button">
                                <span class="material-icons">unfold_more</span>
                                <p>Expand All</p>
                            </div>
                            <div
                                className="expand-collapse-layout"
                                onClick={this.collapseAll}
                                style={{marginLeft:10}}
                                type="button">
                                <span class="material-icons">unfold_less</span>
                                <p>Collapse All</p>
                            </div>

                        </ExpandCollapseWrapper>
                        <TreeViewComponent 
                            fields={this.fields} 
                            allowDragAndDrop={dnd}
                            nodeTemplate={this.HeadingTree}
                            ref = {(treeNode) => {this.reference = treeNode}}
                            nodeDragStop={this.dragStop}
                            nodeDropped = {this.nodeDrop}
                            nodeExpanded = {this.nodeExpanded}
                            nodeCollapsed = {this.nodeCollapsed}
                        />
                    </div>
                </Modal>

                <AddHeadingDialog
                    isEdit={this.state.isEdit}
                    showCreateDialog={this.state.showCreateDialog}
                    handleAddEditDialogClose={this.handleAddEditDialogClose}
                    createNodeType={this.state.createNodeType}
                    parentHeadingId={this.state.relativeFunctionId}
                    rootCheckListVersionId={this.props.rootCheckListVersionId}

                    selectedId={this.state.selectedId}
                    heading={this.state.heading}
                    themeSettings={this.props.themeSettings}
                />

                <AlertWithRadioDialog
                    showAlertDialog={this.state.showAlertWithRadioDialog}
                    handleAlertDialogClose={this.handleAlertWithDialogDialogClose}
                    alertDialogHeading={"Delete"}
                    alertDialogMessage={this.state.alertWithRadioDialogMessage}
                    proceedBtnClick={this.deleteActivateFunctionNode}
                    proceedBtnLabel={"Delete"}
                    showLoader={this.state.showBtnLoader}
                    showRadio={this.state.showRadio}
                />

                <AlertDialog 
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type= {Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={ Constants.ALERT_TYPE_OKAY_LABEL }
                    themeSettings={this.props.themeSettings}
                />

                <ProcessFunctionListDialog
                    handleProcessFuncDialogClose = {this.handleProcessFuncDialogClose}
                    showProcessFunctionsDialog = {this.state.showProcessFunctionsDialog}
                    rootCheckListVersionId={this.props.rootCheckListVersionId}
                    titleType={this.state.titleType}
                    themeSettings={this.props.themeSettings}
                    currentPageNo={this.props.currentPageNo}
                    searchkey={this.props.searchkey}
                    resultSize={this.props.resultSize}
                    sort={this.props.sort}
                    sortDir={this.props.sortDir}
                    status={this.props.status}
                    handleActionDropdownItemClick={this.props.handleActionDropdownItemClick}
                    checkListItem = {this.props.rootNode}
                    checkListHeadingId = {this.state.selectedId}
                    checkListHeading = {this.state.heading}
                    departmentId={this.props.departmentId}
                />
            </div>
        );
    }
}

export default HeadingTreeDialog;